import jQuery from "jquery";
window.jQuery = jQuery;
$ = jQuery;

import { getUrlParameter, hasUrlParameter, setCookie, getCookie, delCookie, forceInt, setModalDisplayFlexToCenterItOnOpen } from "../functions";


$(function() {
    const aModalIsOpen = function() {
        const modals = $('.modal');
        let aModalIsOpen = false;

        if (modals.length) {
            modals.each(function() {
                const $this = $(this);

                if ($this.data('bs.modal') && $this.data('bs.modal').isShown) {
                    aModalIsOpen = true;
                }
            });
        }

        return aModalIsOpen;
    }

    // $('.modal').on('click', function() {
    //     const $this = $(this);
    //
    //     $this.modal('hide');
    // });

    var canShowGuaranteeModal = (
        ($('body.CourseEntry').length && $('.js-ga_addProductToCart').length) ||
        $('body.StarterPage').length ||
        $('body.DealsPage').length ||
        $('body.MultipleDealsPage').length
    );
    // || $('body.VIPSignupPage').length
    // console.log('canShowGuaranteeModal', canShowGuaranteeModal);
    if (canShowGuaranteeModal && !sessionStorage.getItem('HPAGuaranteeModalShown')) {
        setTimeout(function() {
            if (!aModalIsOpen()) {
                $('#guaranteeModal').modal();
                sessionStorage.setItem('HPAGuaranteeModalShown', 1);
            }
        }, 45000);
    }

    var failedPaymentModal = $('#failedPaymentModal');
    if (failedPaymentModal.length) {
        var failureParam = getUrlParameter('failure'),
            failureCode  = getUrlParameter('failureCode'),
            paymentMethodParam = getUrlParameter('paymentMethod');

        if (failureParam && paymentMethodParam === 'DPS' && !aModalIsOpen()) {
            failedPaymentModal.modal();

            const jsGaCheckout = $('.js-ga_checkout');
            if (jsGaCheckout.length) {
                const productInfo = JSON.parse(jsGaCheckout.attr('data-ga_productinfo'));
                const paymentFailEvent = {
                    event: 'paymentFail',
                    purchaseData: {
                        course_id: productInfo[0].id,
                        course_name: productInfo[0].name,
                    },
                    errorData: {
                        error_code: failureCode,
                    },
                };
                // console.log(paymentFailEvent);
                if (window.GtmDefined) {
                    window.dataLayer.push(paymentFailEvent);
                }
            }
        }

        failedPaymentModal.find('.info-modal-btn').on('click', function(e) {
            e.preventDefault();

            failedPaymentModal.modal('hide');

            $('html, body').animate({
                scrollTop: $('#btnPayNow').offset().top
            });

            $('#RadioPayPal').trigger('click');
            $('#btnPayNow').trigger('click');
            $('#btnPayNow').text(hpaTranslatedtext.infoModal.redirectingToPayPal); // Redirecting to PayPal...
        });
    }

    // const paymentConfirmationExitModal = $('#paymentConfirmationExitModal');
    // if (paymentConfirmationExitModal.length) {
    //     let paymentConfirmationExitModalHasOpened = false,
    //         radioField = false,
    //         paymentMethodFieldIsSelected = false;
    //     const radioFields = $('input[name="PaymentPlan"]');
    //     radioFields.each(function() {
    //         const $this = $(this),
    //             value = $this.val();
    //         if (value.match(/[1-9]+\-Weekly/i)) {
    //             radioField = $this;
    //         }
    //     });
    //
    //     if (radioField) {
    //         const price = radioField.siblings('label').find('.js-total').text();
    //         paymentConfirmationExitModal.find('.exit-modal-main-heading').find('span').text(price);
    //         if (price.length && window.location.host !== 'lh.hpacademy.com') {
    //             $(document).on('mouseleave', function() {
    //                 if (!paymentConfirmationExitModalHasOpened && !aModalIsOpen()) {
    //                     paymentConfirmationExitModal.modal('show');
    //                     paymentConfirmationExitModalHasOpened = true;
    //                     const selectedPaymentMethodField = $('[name="PaymentType"]:checked');
    //                     if (selectedPaymentMethodField.length) paymentMethodFieldIsSelected = true;
    //                 }
    //             });
    //         }
    //
    //         paymentConfirmationExitModal.find('.info-modal-btn').on('click', function(e) {
    //             e.preventDefault();
    //
    //             paymentConfirmationExitModal.modal('hide');
    //
    //             let scrollToID = 'payment-method-section';
    //             if (paymentMethodFieldIsSelected) scrollToID = 'payment-plan-section';
    //
    //             $('html, body').animate({
    //                 scrollTop: $('#' + scrollToID).offset().top
    //             });
    //
    //             radioField.attr('checked', true);
    //             $('.js-prompt--paymentPlan a').trigger('click');
    //         });
    //     }
    // }

    /* Commented this out for "Test 132 - Interstitial vs Giveaway"
    const newletterInterstitialAllowedURLs = [
        '/forum/',
        '/blog/',
        '/technical-articles/',
    ];

    let niPageValid = false;
    for (const pagePath of newletterInterstitialAllowedURLs) {
        if (window.location.pathname.indexOf(pagePath) != -1) {
            niPageValid = true;
        }
    }

    if (niPageValid && gtmMemberData === false) {
        let niPopupFuncName = 'niPopup2';
        const niIsFirstVisit = function() {
                let result = false;

                if (!getCookie('visit-type') && !sessionStorage.getItem('first-visit-session')) {
                    setCookie('visit-type', 'first-visit', 365);
                    sessionStorage.setItem('first-visit-session', true);
                    result = true;
                } else if ((getCookie('visit-type') == 'first-visit') && sessionStorage.getItem('first-visit-session')) {
                    result = true;
                } else if (getCookie('visit-type') == 'first-visit') {
                    setCookie('visit-type', 'returning visitor', 365);
                }

                return result;
            },
            niPopup1 = function() {
                if (sessionStorage.getItem('hpa-popup-done') || aModalIsOpen()) return false;

                const generalForm = $('#general-email-form'),
                    niSignupModal = $('#newletterInterstitialSignupModal');

                if (generalForm.length && niSignupModal.length) {
                    let generalFormHtml = $('#general-email-form').html();
                    $('#general-email-form').remove();
                    niSignupModal.find('.info-modal-content-form').prepend(generalFormHtml);
                    $('#GeneralEmailForm_GeneralEmailForm').parsley();
                    $('#GeneralEmailForm_GeneralEmailForm_Name').attr('placeholder', 'First Name');
                    $('#GeneralEmailForm_GeneralEmailForm_Type').val('#newletter-interstitial');
                    $('#GeneralEmailForm_GeneralEmailForm button[type="submit"]').text('Unlock Free Content');
                    $('#GeneralEmailForm_GeneralEmailForm').on('submit', function() {
                        if (window.GtmDefined) {
                            window.dataLayer.push({
                                'event': 'email_Lead',
                            });
                        }
                    });
                    niSignupModal.modal('show');
                    sessionStorage.setItem('hpa-popup-done', true);
                }
            },
            niPopup2 = function() {
                if (sessionStorage.getItem('hpa-popup-done') || aModalIsOpen()) return false;

                const niJITModal = $('#newletterInterstitialJITModal');

                if (niJITModal.length) {
                    niJITModal.modal('show');
                    sessionStorage.setItem('hpa-popup-done', true);
                }
            };

        if (niIsFirstVisit()) {
            niPopupFuncName = 'niPopup1';
        }

        const tvar = forceInt(getUrlParameter('tvar'));
        const isTest = (tvar === 132 ? true : false);
        console.log({tvar, isTest});
        let niPopupTimeMilliseconds = 2000;
        if (isTest) {
            niPopupTimeMilliseconds = 30000;
        }

        console.log({niPopupFuncName, niPopupTimeMilliseconds});

        setTimeout(function() {
            eval(niPopupFuncName + '()');
        }, niPopupTimeMilliseconds); // 60000

        $(document).on('mouseleave', function() {
            eval(niPopupFuncName + '()');
        });

    }*/

    // This is the winner for "Test 132 - Interstitial vs Giveaway"
    const newletterInterstitialAllowedURLs = [
        '/forum/',
        '/blog/',
        '/technical-articles/',
    ];

    let niPageValid = false;
    for (const pagePath of newletterInterstitialAllowedURLs) {
        if (window.location.pathname.indexOf(pagePath) != -1) {
            niPageValid = true;
        }
    }

    if (niPageValid && gtmMemberData === false) {
        let niPopupFuncName = 'niGiveawayPopup';
        const niGiveawayPopup = function() {
            if (sessionStorage.getItem('hpa-niGiveawayPopup-done') || aModalIsOpen()) return false;
            const giveawayModal = $('#GiveawayModal');
            if (giveawayModal.length) {
                giveawayModal.modal('show');
                sessionStorage.setItem('hpa-niGiveawayPopup-done', true);
            }
        };

        let niPopupTimeMilliseconds = 1000;

        setTimeout(function() {
            // eval(niPopupFuncName + '()');
            window[niPopupFuncName]();
        }, niPopupTimeMilliseconds);
    }

    $('.info-modal').on('show.bs.modal', function() {
        const $this = $(this);

        setModalDisplayFlexToCenterItOnOpen($(this)); // themes/base/less/layout/infoModal.less line 390
    });

    const rafModal = $('#RafModal');
    if (rafModal.length) {

        rafModal.on('show.bs.modal', function() {
            setModalDisplayFlexToCenterItOnOpen($(this)); // themes/base/less/layout/infoModal.less line 390
        });

        // rafModal.on('hide.bs.modal', function() {
        //     sessionStorage.setItem('RafModalClosed', 'true');
        // });

        if (!aModalIsOpen()) {
            const currentTimestamp = new Date().getTime(),
                reopenModalInterval = 300000, // 300000 milliseconds since last opened
                rafCode = getCookie('HpaRaf'), // this is set when the modal is opened for the first time
                rafEmail = getCookie('HpaRafEmail'); // this will not be empty if they have submitted the form

            let openRafModal = false,
                lsTimestamp = parseInt(localStorage.getItem('HpaRafModalLastOpened'));
            if (isNaN(lsTimestamp)) lsTimestamp = 0;

            const disallowedPagePaths = [
                '/payment/',
            ];
            let pageValid = true;
            for (const disallowedPagePath of disallowedPagePaths) {
                if (window.location.pathname.indexOf(disallowedPagePath) != -1) {
                    pageValid = false;
                }
            }

            if (getUrlParameter('raf')) { // this will be their first time loading the modal becuase they are using the rerral link
                openRafModal = true;
            } else if (rafCode && !rafEmail && pageValid && (lsTimestamp > 0) && ((currentTimestamp-lsTimestamp) > reopenModalInterval)) {
                if (gtmMemberData === false || (gtmMemberData && !gtmMemberData.last_purchase_date)) {
                    openRafModal = true;
                }
            }

            // console.log({rafCode, rafEmail, currentTimestamp, openRafModal, pageValid, lsTimestamp, lsGtNow: ((currentTimestamp-lsTimestamp) > reopenModalInterval)});

            if (openRafModal) {
                rafModal.modal('show');
                localStorage.setItem('HpaRafModalLastOpened', currentTimestamp);
            }
        }
    }

    const rafUrlModal = $('#RafUrlModal'),
        rafUrlModalTrigger = $('.trigger-raf-url-modal');
    if (rafUrlModal.length && (rafUrlModalTrigger.length || $('.DashboardHomePage').length || $('.DashboardCoursesPage').length)) {

        rafUrlModalTrigger.on('click touch', function() {
            rafUrlModal.modal('show');
        });

        rafUrlModal.on('show.bs.modal', function() {
            setModalDisplayFlexToCenterItOnOpen($(this)); // themes/base/less/layout/infoModal.less line 390
        });

        rafUrlModal.on('hide.bs.modal', function() {
            // sessionStorage.setItem('RafUrlModalClosed', 'true');
        });

        let rafUrlModalAutoOpen = false,
            rafUrlModelShown = forceInt(sessionStorage.getItem('HpaRafUrlModelShown')),
            rafUrlModelShownCount = forceInt(getCookie('HpaRafUrlModelShownCount')),
            hasReferred = forceInt(getCookie('HpaRafHasReferredAFriend'));

        if (!aModalIsOpen()) {
            if (gtmMemberData && gtmMemberData.subscription != 'VIP' && !hasReferred) {
                if (getUrlParameter('raf-url-modal')) {
                    rafUrlModalAutoOpen = true;
                } else if (!rafUrlModelShown && rafUrlModelShownCount < 5) {
                    rafUrlModalAutoOpen = true;
                }
            }
        }

        if (rafUrlModalAutoOpen) { // !sessionStorage.getItem('RafUrlModalClosed')
            rafUrlModal.modal('show');
            sessionStorage.setItem('HpaRafUrlModelShown', 1);
            setCookie('HpaRafUrlModelShownCount', (rafUrlModelShownCount+1), 9999);
        }
    }

    const car2dbModal = $('#Car2DBModal');
    if (car2dbModal.length) {
        car2dbModal.on('show.bs.modal', function() {
            setModalDisplayFlexToCenterItOnOpen($(this)); // themes/base/less/layout/car2db.less line 335
        });

        const car2dbCheck = getCookie('HpaCar2dbCheck'), // have they already added a vehicle or ticked they don't have one
            car2dbModalNotAllowedURLs = [
                '/garage',
                '/payment',
                '/account/profile',
            ];
        let car2dbModalShow = true;
        for (const pagePath of car2dbModalNotAllowedURLs) {
            if (window.location.pathname.indexOf(pagePath) != -1) {
                car2dbModalShow = false;
            }
        }
        if (aModalIsOpen() || car2dbCheck === 'true' || car2dbCheck === null || gtmMemberData === false) {
            car2dbModalShow = false;
        }

        if (car2dbModalShow) {
            car2dbModal.modal('show');
        }

        car2dbModal.find('.no-vehicle').on('click', function() {
            car2dbModal.modal('hide');
            $.get('/dashboard/garage-json', 'act=updateCar2DBNoVehicles&value=1', function(data) {
                // console.log(data);
            }, 'json');
        });
    }

    const $localeModal = $('#localeModal');
    if ($localeModal.length) {
        $localeModal.on('show.bs.modal', function() {
            setModalDisplayFlexToCenterItOnOpen($(this)); // themes/base/less/layout/infoModal.less line 390
        });

        $localeModal.on('click.dismiss.bs.modal', function() {
            const now = new Date();
            now.setFullYear(now.getFullYear() + 1);
            const expires = now.toUTCString();
            document.cookie = `HpaFluentLocaleModal_Closed=1; expires=${expires}; path=/`;
        });

        if (!aModalIsOpen()) {
            $localeModal.modal('show');
        }
    }

    const $calculatorPageVideoModal = $('#calculatorPageVideoModal');
    if ($calculatorPageVideoModal.length) {
        $calculatorPageVideoModal.on('show.bs.modal', function() {
            setModalDisplayFlexToCenterItOnOpen($(this)); // themes/base/less/layout/infoModal.less line 390
        });

        $('.calculator-page-video-modal-show').on('click', function(e) {
            e.preventDefault();

            if (!aModalIsOpen()) {
                $calculatorPageVideoModal.modal('show');
            }
        });
    }

    const $memberReviewsModal = $('#memberReviewsModal');
    if ($memberReviewsModal.length) {
        $memberReviewsModal.on('show.bs.modal', function() {
            setModalDisplayFlexToCenterItOnOpen($(this)); // themes/base/less/layout/infoModal.less line 390
        });

        $('.member-reviews-modal-show').on('click', function(e) {
            e.preventDefault();

            if (!aModalIsOpen()) {
                $memberReviewsModal.modal('show');
            }
        });
    }
});



// WEBPACK FOOTER //
// ./js/modules/infoModal.js